import './App.css';
import { Outlet } from 'react-router-dom';
import TopNavPublic from './Components/Navigation/TopNavPublic';
import RouteAnalytics from './Components/Common/RouteAnalytics';

function AppPublic() {
  return (
    <>
      <RouteAnalytics />
      <TopNavPublic></TopNavPublic>
      <div className=''>
        <Outlet></Outlet>
      </div>
    </>
  );
}

export default AppPublic;
